import React from "react"
import { DadosFornecedorContextProvider } from "./context/DadosFornecedorContextProvider"
import { DadosFornecedor } from "./DadosFornecedor"

export function Index() {
    return (
        <DadosFornecedorContextProvider>
            <DadosFornecedor />
        </DadosFornecedorContextProvider>
    )
}
